import { object, array, TypedForm, ObjectSchema } from 'libs/form';
import {
  WithdrawalAccountFormType,
  withdrawalAccountSchema,
} from 'modules/client/common/forms/withdrawalAccountForm';

export interface WithdrawalAccountsFormType {
  withdrawalAccounts: WithdrawalAccountFormType[];
}

export const withdrawalAccountsSchema: ObjectSchema<WithdrawalAccountsFormType> =
  object({
    withdrawalAccounts: array()
      .of(withdrawalAccountSchema.required())
      .required()
      .min(1),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<WithdrawalAccountsFormType>();
